import React from 'react';
import FormHelperText from '@mui/joy/FormHelperText';
import { UC_DISALLOWED_TILDE_MESSAGE } from './ucDisallowedSymbol';

const UcTildeWarning = () => (
  <FormHelperText
    data-testid="uc-tilde-warning"
    sx={{
      color: '#B45309',
      fontSize: '0.875rem',
      width: '100%',
      mt: 0.25,
    }}
  >
    {UC_DISALLOWED_TILDE_MESSAGE}
  </FormHelperText>
);

export default UcTildeWarning;
